/**
 * Media query utility - reads breakpoint from CSS :before pseudo-element
 */
import type { MediaQuery } from '../types'

export function getMediaQuery(): MediaQuery {
  const value = window
    .getComputedStyle(document.body, ':before')
    .getPropertyValue('content')
    .replace(/["']/g, '')

  return value as MediaQuery
}
